import { Alert, CircularProgress } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import {
  useGetMaterialChemistrySetQuery,
  useGetMaterialMetadataSetQuery,
  useListChemicalElementsQuery,
} from "store/api/generatedApi";
import { MaterialChemistryDefaultsEditor } from "./MaterialChemistryDefaultsEditor";

export const MaterialChemistryDefaultParameters = ({
  isActive,
  setConfirmOpen,
}: {
  isActive: boolean;
  setConfirmOpen: (open: boolean) => void;
}) => {
  const tenantName = useTenant();
  const { t } = useTenantTranslation();
  const chemistry = useGetMaterialChemistrySetQuery({
    tenantName,
    materialChemistrySetId: "default",
  });
  const materials = useGetMaterialMetadataSetQuery({
    tenantName,
    materialMetadataSetId: "default",
  });
  const elements = useListChemicalElementsQuery({ tenantName });
  if (
    (chemistry.isError && !chemistry.currentData) ||
    (materials.isError && !materials.currentData) ||
    (elements.isError && !elements.currentData)
  ) {
    return <Alert severity="error">{t("errorLoadingData")}</Alert>;
  }
  if (
    !chemistry.currentData ||
    !materials.currentData ||
    !elements.currentData
  ) {
    return <CircularProgress />;
  }
  return (
    <MaterialChemistryDefaultsEditor
      key={tenantName}
      isActive={isActive}
      setConfirmOpen={setConfirmOpen}
      defaultSet={chemistry.currentData}
      materials={materials.currentData.materials}
      chemicalElements={elements.currentData.filter(
        (element) => element.status === "modelled"
      )}
      refresh={chemistry.refetch}
    />
  );
};
